import { UserType } from '@nemuru-eng/js-api-client';
import { useState } from 'react';

import { useUser } from '@/hooks/useUser';

import { TimeInterval } from '../entities/TimeInterval';
import { TimeIntervalType } from '../types/TimeIntervalType';

export const useTimeInterval = () => {
  const { userEntity } = useUser();

  const [timeInterval, setTimeInterval] = useState(
    new TimeInterval(
      userEntity?.hasUserType([UserType.MERCHANT_GROUP, UserType.MERCHANT, UserType.CHANNEL, UserType.AGENT])
        ? TimeIntervalType.THIS_MONTH
        : TimeIntervalType.TODAY,
    ),
  );

  return { timeInterval, setTimeInterval };
};
